import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import useFetch from "../../hooks/useFetch";

const MSMEWhySakshamMSME = () => {
  const authState = useSelector((state) => state.authReducer);
  const [activeTab, setActiveTab] = useState("vision");
  const [isError, setIsError] = useState(false);
  const navigate = useNavigate();
  const [fetchData, { loading }] = useFetch();

  const handleTabClick = (tab) => {
    if (tab.id === 'problems') {
      navigate(tab.route);
    } else {
      setActiveTab(tab.id);
    }
  };

  const kititems = [
    {
      id: 1,
      title: "Startup Kit",
      description:
        "Access over 220 ready-to-use business templates to streamline HR, operations, finance, marketing, and compliance.",
      img: "/api/downloads/thinkdscut/sakshambharat/courses/startup-kit.jpg",
    },
    {
      id: 2,
      title: "MSME Owner Productivity Hack eBook",
      description:
        "Tools and techniques to maximize personal and team efficiency for MSME owners.",
      img: "/api/downloads/thinkdscut/sakshambharat/courses/productivity-hack.jpg",
    },
    {
      id: 3,
      title: "MSME Digital Readiness & BPM Maturity Evaluation Kit",
      description:
        "A structured guide to evaluate digital transformation and business process management maturity.",
      img: "/api/downloads/thinkdscut/sakshambharat/courses/digital-readiness.jpg",
    },
    {
      id: 4,
      title: "RACI Matrix Guide",
      description:
        "Define and communicate roles and responsibilities within your team or project with this responsibility assignment tool.",
      img: "/api/downloads/thinkdscut/sakshambharat/courses/raci-matrix.jpg",
    },
    {
      id: 5,
      title: "AIfy MSME: A Digital Book",
      description:
        "Practical insights for adopting AI in MSME business processes to enhance efficiency.",
      img: "/api/downloads/thinkdscut/sakshambharat/courses/aify-msme.jpg",
    },
    {
      id: 6,
      title: "Purple Power: Six Sigma for MSMEs",
      description:
        "A lightweight, MSME-specific guide to Six Sigma for achieving process excellence.",
      img: "/api/downloads/thinkdscut/sakshambharat/courses/purple-power.jpg",
    },
    {
      id: 7,
      title: "FLOURISH: Financial Literacy for MSMEs",
      description:
        "Essential financial literacy eBook to empower MSMEs with financial management skills.",
      img: "/api/downloads/thinkdscut/sakshambharat/courses/flourish.jpg",
    },
    {
      id: 8,
      title: "Cyberwisdom for MSMEs",
      description:
        "A comprehensive eBook on cybersecurity awareness tailored for MSME needs.",
      img: "/api/downloads/thinkdscut/sakshambharat/courses/cyberwisdom.jpg",
    },
    {
      id: 9,
      title: "JAGRUK: Legal & Civic Literacy",
      description:
        "Justice Awareness Guidance Rights Unity Knowledge eBook for basic legal and civic literacy.",
      img: "/api/downloads/thinkdscut/sakshambharat/courses/jagruk.jpg",
    },
    {
      id: 10,
      title: "Think5Whys: Problem-Solving Mastery",
      description:
        "Learn the 5 Whys analysis technique for systematic root cause problem-solving.",
      img: "/api/downloads/thinkdscut/sakshambharat/courses/think5whys.jpg",
    },
    {
      id: 11,
      title: "MSME Loans Demystified",
      description:
        "A complete guide to financial empowerment, risk-free borrowing, and smart growth for MSMEs.",
      img: "/api/downloads/thinkdscut/sakshambharat/courses/loans-demystified.jpg",
    },
  ];

  const features = [
    { title: "Tailored for MSMEs", emoji: "🏭", desc: "Tools and courses designed specifically for Indian MSMEs to boost productivity." },
    { title: "Expert-Led Guidance", emoji: "👨‍🏫", desc: "Learn from industry veterans and process experts in Kaizen and BPM." },
    { title: "Think5Whys Methodology", emoji: "🧠", desc: "Master root cause analysis with our proprietary 5 Whys approach." },
    { title: "Digital Transformation", emoji: "💻", desc: "Access cloud-based platforms for seamless process and digital readiness." },
    { title: "Practical Toolkits", emoji: "🛠️", desc: "220+ templates for HR, finance, operations, and compliance." },
    { title: "AI Integration", emoji: "🤖", desc: "Practical AI tools to enhance MSME operations and decision-making." },
    { title: "Scalable Growth", emoji: "📈", desc: "Structured frameworks for sustainable and competitive business growth." },
    { title: "Community Support", emoji: "🤝", desc: "Join a network of MSMEs, banks, and experts for collaborative growth." },
    { title: "SAKSHAM Certification", emoji: "📜", desc: "Earn a certificate to showcase your business’s process maturity." },
  ];

  const tabs = [
  { id: 'problems', label: '❌ Problems & Solutions', route: '/msme-visionpage' },
  { id: 'vision', label: '👁️ Vision & Mission' },
  { id: 'features', label: '✨ Why SAKSHAM' },
  { id: 'kit', label: '🎒 Literacy Kit' },
  { id: 'certificate', label: '🏆 Certificate' },
];

  return (
    <div className="min-h-screen flex flex-col bg-black">
      <header className="flex flex-col justify-start items-start border-b border-blue-400 px-2 py-2 bg-black text-white shadow-md sticky top-0 z-50">
        <h1 className="text-lg lg:text-xl font-extrabold text-yellow-200">SAKSHAM MSME</h1>
        <p className="text-xs lg:text-sm text-white">
          Skilled And Keen, Systematic Hands Achieve More!
        </p>
      </header>
      <nav className="bg-black border-b border-blue-400 sticky top-[56px] z-40 p-2">
        <div className="grid grid-cols-3 lg:grid-cols-5 gap-2 place-items-center">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => handleTabClick(tab)}
              className={`w-full text-center text-xs lg:text-sm font-semibold px-2 py-2 rounded-md transition 
                ${
                  activeTab === tab.id
                    ? "bg-green-700 text-yellow-200 border-b-2 border-teal-600"
                    : "bg-green-900 text-white hover:bg-green-700 hover:text-white"
                }`}
            >
              {tab.emoji} {tab.label}
            </button>
          ))}
        </div>
      </nav>
      <main className="flex-1 p-2">
        {activeTab === "problems" && (
          <section className="space-y-6 text-gray-100">
            <h2 className="text-xl font-bold text-center text-yellow-200">
              Problems SAKSHAM MSME Identifies & Solutions Offer
            </h2>
            <div className="space-y-6">
              
            </div>
          </section>
        )}
        {activeTab === "vision" && (
          <section className="space-y-3 text-white [&>p]:text-white ">
            <h2 className="text-xl font-bold text-center text-yellow-200">
              Vision, Mission & Values
            </h2>
            <div className="space-y-3 [&>p]:text-white">
              <div className="bg-black text-white p-2 rounded-xl shadow-md">
                <h3 className="text-sm lg:text-lg font-semibold mb-2 text-yellow-200">🌟 Vision</h3>
                <p className="text-white">
                  To empower 60 million Indian MSMEs by 2035, creating a globally competitive, process-driven ecosystem that drives innovation, productivity, and sustainable growth.
                </p>
              </div>
              <div className="bg-black text-white p-2 rounded-xl shadow-md">
                <h3 className="text-sm lg:text-lg font-semibold mb-2 text-yellow-200">🎯 Mission</h3>
                <ul className="list-disc list-inside space-y-2 [&>li]:text-white">
                  <li>Deploy 10 million Quality & Process professionals to transform MSMEs.</li>
                  <li>Provide practical tools like the SAKSHAM Bharat Kit.</li>
                  <li>Foster partnerships with banks, experts, and communities.</li>
                  <li>Promote Kaizen and AI-driven solutions for competitiveness.</li>
                </ul>
              </div>
              <div className="bg-black text-white p-2 rounded-xl shadow-md">
                <h3 className="text-sm lg:text-lg font-semibold mb-2 text-yellow-200">💡 Core Values</h3>
                <ul className="list-disc list-inside space-y-1 [&>li]:text-white">
                  <li>Empowerment — Tools for self-reliance.</li>
                  <li>Innovation — Digital and process transformation.</li>
                  <li>Collaboration — Ecosystem partnerships.</li>
                  <li>Excellence — Measurable outcomes.</li>
                  <li>Inclusivity — Access for all MSMEs.</li>
                </ul>
              </div>
            </div>
          </section>
        )}

        {activeTab === "features" && (
          <section>
            <h2 className="text-xl font-bold text-center text-yellow-200 mb-4">
              Why Choose SAKSHAM Bharat?
            </h2>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
              {features.map((f, i) => (
                <div key={i} className="bg-black text-white p-5 rounded-xl shadow-md text-center">
                  <div className="text-2xl mb-2 text-white">{f.emoji}</div>
                  <h4 className="font-semibold mb-1 text-white">{f.title}</h4>
                  <p className="text-sm text-gray-100">{f.desc}</p>
                </div>
              ))}
            </div>
          </section>
        )}

        {activeTab === "kit" && (
          <section>
            <h2 className="text-xl font-bold text-center text-teal-700 mb-4">
              SAKSHAM MSME Literacy Kit
            </h2>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
              {kititems.map((item) => (
                <div
                  key={item.id}
                  className="bg-black text-white rounded-xl shadow-md hover:shadow-lg transition overflow-hidden"
                >
                  <img src={item.img} alt={item.title} className="w-full h-40 object-cover" />
                  <div className="p-2">
                    <h3 className="text-lg font-semibold text-gray-100">
                      {item.title}
                    </h3>
                    <p className="text-sm text-gray-100 mt-2">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>
        )}

        {activeTab === "certificate" && (
          <section className="text-center text-gray-200">
            <h2 className="text-xl font-bold text-yellow-200 mb-4">
              Why SAKSHAM MSME Certificate?
            </h2>
            <div className="text-white mx-auto">
              <p className="text-white mb-3">
                Empowered with knowledge, equipped with tools—this certificate
                honors the spirit of self-reliance and excellence in India’s MSME
                journey.
              </p>
              <p className="text-white">
                The SAKSHAM MSME Certificate is an optional recognition awarded
                to eligible subscribers who clear the SAKSHAM MSME Aptitude Test.
              </p>
            </div>
          </section>
        )}
      </main>
      <footer className="bg-black border-t border-blue-400 text-white py-4 px-4">
        <div className="flex flex-col lg:flex-row justify-between items-center text-center">
          <p className="text-xs lg:text-sm">&copy; 2025 Think5Whys Global DeepTech Solutions. </p>
          <div className="flex text-white space-x-6 mt-3 text-xs lg:text-sm">
            <Link to="/about-us" className="text-white hover:text-blue-300">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-blue-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-blue-300">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-blue-300">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default MSMEWhySakshamMSME;
